export const smsFromEstheticianToClient = estheticianName =>
  `POMP BEAUTY: Your Pomp esthetician ${estheticianName} has sent you a new message. Please visit ${window.location.hostname}?messaging=true to view it.`;

export const smsFromClientToEsthetician = clientName =>
  `POMP BEAUTY: You have received a new message from Pomp client, ${clientName}. Please visit ${window.location.hostname}/messaging to view it.`;
